module.exports = __webpack_public_path__ + "static/img/ic_file_video.ab6e7e40.png";